import { useContext } from "react";
import { ProfileContext } from "../providers/profile-provider.tsx";

export const useProfileContext = () => {
    const ctx = useContext(ProfileContext);

    if (!ctx) {
        throw new Error("useProfileContext must be within ProfileProvider");
    }

    return ctx;
};
